import { render, staticRenderFns } from "./CrossCountryResultComponent.vue?vue&type=template&id=2e00ecc5&scoped=true"
import script from "./CrossCountryResultComponent.vue?vue&type=script&lang=ts"
export * from "./CrossCountryResultComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e00ecc5",
  null
  
)

export default component.exports